var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-base',{attrs:{"width":100+'%',"fill":_vm.color,"viewBox":"0 0 576.767 576.767"}},[_c('ellipse',{attrs:{"id":"Ellipse_465","data-name":"Ellipse 465","cx":"288.383","cy":"288.383","rx":"288.383","ry":"288.383","fill":"#f7d752"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }